import React from 'react';
import { Switch } from 'react-router-dom';

import { rolesRoute } from '~/routes'
import RouteWrapper from '~/routes/RouteWrapper';
import List from './List';
import Show from './Show';
import Edit from './Edit';
import New  from './New';

export default function RolesRoutesComponent() {
  return (
    <Switch>
      <RouteWrapper
        exact
        isPrivate
        path={rolesRoute.new.path}
        component={New}
        permissionKeyCode="Role"
        permission="add"
      />
      <RouteWrapper
        exact
        isPrivate
        path={rolesRoute.clone.path}
        component={New}
        permissionKeyCode="Role"
        permission="add"
      />
      <RouteWrapper
        exact
        isPrivate
        path={rolesRoute.show.path}
        component={Show}
        permissionKeyCode="Role"
        permission="see"
      />
      <RouteWrapper
        exact
        isPrivate
        path={rolesRoute.edit.path}
        component={Edit}
        permissionKeyCode="Role"
        permission="edit"
      />

      <RouteWrapper
        isPrivate
        redirectIfNotExact
        path={rolesRoute.list.path}
        component={List}
        permissionKeyCode="Role"
        permission="see"
      />
    </Switch>
  );
}
